/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects"

import {
  LOAD_RECORDS_META_DATA,
  LOAD_EMPLOYEE,
  LOAD_OBS_LIST,
  ADD_ASSIGN,
  ADD_FOLLOWUP,
  LOAD_FOLLOWUP,
  ADD_COMPANY,
  LOAD_COMPANY
} from "./constants"

import {
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  loadEmployee,
  loadEmployeeSuccess,
  loadEmployeeError,
  loadManageObsLeadList,
  loadManageObsLeadListSuccess,
  loadManageObsLeadListError,
  addAssignSuccess,
  addAssignError,
  addFollowUpSuccess,
  addFollowUpError,
  loadFollowUpSuccess,
  loadFollowUpError,
  loadFollowUp,
  loadCompany,
  loadCompanySuccess,
  loadCompanyError,
  addCompanyError,
  addCompanySuccess,

} from "./actions"

import {
  loadRecordsMetaData,
  loadEmployeeList,
  loadManageObsLeadDetails,
  addAssignRemote,
  addFollowUpRemote,
  loadFollowUpDetails,
  addCompanyDetails,
  loadCompanyDetails
} from "./remotes"

function* loadEmployeeSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_EMPLOYEE),
    })

    const { explicitLoad } = load

    // const { id } = explicitLoad || {}
    yield put(loadEmployee(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadEmployeeList)

        if (result) {
          yield put(loadEmployeeSuccess(result.data))
        } else {
          yield put(loadEmployeeError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadEmployeeError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadObsDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_OBS_LIST),
    })

    const { explicitLoad } = load

    const { searchFilter } = explicitLoad || {}
    yield put(loadManageObsLeadList(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadManageObsLeadDetails, searchFilter)

        console.log(result, "result")

        if (result) {
          yield put(loadManageObsLeadListSuccess(result.data))
          console.log(result.Data, "result")
        } else {
          yield put(loadManageObsLeadListSuccess([]))
          yield put(loadManageObsLeadListError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadManageObsLeadListSuccess([]))
        yield put(
          loadManageObsLeadListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

//
function* addAssignSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { add } = yield race({
      add: take(ADD_ASSIGN),
    })
    const { submitAssign } = add || {}
    if (add) {
      try {
        yield call(addAssignRemote, submitAssign)
        yield put(addAssignSuccess(submitAssign, "Record Updated Successfully"))
      } catch (error) {
        yield put(
          addAssignError(
            (error && error.response && error.response.message) ||
              "Updated Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

//
function* addFollowUpSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { add } = yield race({
      add: take(ADD_FOLLOWUP),
    })
    const { submitFollowUp } = add || {}
    if (add) {
      try {
        yield call(addFollowUpRemote, submitFollowUp)
        yield put(
          addFollowUpSuccess(submitFollowUp, "Record Updated Successfully")
        )
      } catch (error) {
        yield put(
          addFollowUpError(
            (error && error.response && error.response.message) ||
              "Updated Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
      const payload = {"mode" : "sales"}
      const processStatus = yield call(
        loadRecordsMetaData,
        "process_status",
        "post",payload
      )
      const process = yield call(
        loadRecordsMetaData,
        "process_status",
        "post"
      )
      const company = yield call(loadRecordsMetaData, "company", "post")
      const branch = yield call(loadRecordsMetaData, "branch", "post")
      const service = yield call(loadRecordsMetaData, "lead_service", "post")
      const followupStrategy = yield call(
        loadRecordsMetaData,
        "followup_strategy",
        "post"
      )
      const followupMode = yield call(
        loadRecordsMetaData,
        "followup_master",
        "post"
      )
      const followupAction = yield call(
        loadRecordsMetaData,
        "followup_action",
        "post"
      )
      const rejectReason = yield call(
        loadRecordsMetaData,
        "rejectreason",
        "post"
      )
      console.log(followupAction, "action")
      const source = yield call(loadRecordsMetaData, "source", "post")
      console.log(followupStrategy, "strategy")
      console.log(followupMode, "mode")
      let obsMetaData = {
        companyOptions:
          (company &&
            company.data &&
            company.data.length > 0 &&
            company.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign({}, { label: c.name, value: c._id })
              )) ||
          [],
        sourceOptions:
          (source &&
            source.data &&
            source.data.length > 0 &&
            source.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign({}, { label: c.sourceName, value: c._id })
              )) ||
          [],
        serviceOptions:
          (service &&
            service.data &&
            service.data.length > 0 &&
            service.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  { label: c.service, value: c._id, companyId: c.companyId }
                )
              )) ||
          [],
        branchOptions:
          (branch &&
            branch.data &&
            branch.data.length > 0 &&
            branch.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  { label: c.name, value: c._id, companyId: c.companyId }
                )
              )) ||
          [],
        processStatusOptions:
          (processStatus &&
            processStatus.data &&
            processStatus.data.length > 0 &&
            processStatus.data
              .filter((_) => _.status === 1)
              .map((p) =>
                Object.assign(
                  {},
                  {
                    label: p.processStatus,
                    value: p.processStatusId,
                    colorCode: p.colorCode,
                  }
                )
              )) ||
          [],
          processColorOptions:
          (process &&
            process.data &&
            process.data.length > 0 &&
            process.data
              .filter((_) => _.status === 1)
              .map((p) =>
                Object.assign(
                  {},
                  {
                    label: p.processStatus,
                    value: p.processStatusId,
                    colorCode: p.colorCode,
                  }
                )
              )) ||
          [],
        followUpStrategyOptions:
          (followupStrategy &&
            followupStrategy.data &&
            followupStrategy.data.length > 0 &&
            followupStrategy.data
              .filter((_) => _.status === 1)
              .map((e) =>
                Object.assign(
                  {},
                  {
                    label: `${e.followupStrategy}`,
                    value: e._id,
                  }
                )
              )) ||
          [],
        followUpModeOptions:
          (followupMode &&
            followupMode.data &&
            followupMode.data.length > 0 &&
            followupMode.data
              .filter((_) => _.status === 1)
              .map((e) =>
                Object.assign(
                  {},
                  {
                    label: `${e.followupMaster}`,
                    value: e._id,
                  }
                )
              )) ||
          [],
        followUpStatusOptions:
          (followupAction &&
            followupAction.data &&
            followupAction.data.length > 0 &&
            followupAction.data
              .filter((_) => _.status === 1)
              .map((e) =>
                Object.assign(
                  {},
                  {
                    label: `${e.followupAction}`,
                    value: e._id,
                  }
                )
              )) ||
          [],
          rejectReasonOptions:
          (rejectReason &&
            rejectReason.data &&
            rejectReason.data.length > 0 &&
            rejectReason.data
              .filter((_) => _.status === 1)
              .map((e) =>
                Object.assign(
                  {},
                  {
                    label: e.reason,
                    value: e._id,
                  }
                )
              )) ||
          [],
      }

      yield put(loadRecordsMetaDataSuccess(obsMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}
function* loadFollowUpSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_FOLLOWUP),
    })

    const { explicitLoad } = load

    const { ID } = explicitLoad || {}
    yield put(loadFollowUp(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadFollowUpDetails, ID)

        console.log(result, "result")

        if (result) {
          yield put(loadFollowUpSuccess(result.data))
          console.log(result.Data, "result")
        } else {
          yield put(loadFollowUpSuccess([]))
          yield put(loadFollowUpError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadFollowUpSuccess([]))
        yield put(
          loadFollowUpError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}
function* loadCompanySaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_COMPANY),
    })

    const { explicitLoad } = load

    const { ID } = explicitLoad || {}
    yield put(loadCompany(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadCompanyDetails, ID)

        console.log(result, "result")

        if (result) {
          yield put(loadCompanySuccess(result.data))
          console.log(result.Data, "result")
        } else {
          yield put(loadCompanySuccess([]))
          yield put(loadCompanyError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadCompanySuccess([]))
        yield put(
          loadCompanyError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* addCompanySaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { add } = yield race({
      add: take(ADD_COMPANY),
    })
    const { company_details} = add || {}
    if (add) {
      try {
        yield call(addCompanyDetails, company_details)
        yield put(addCompanySuccess(company_details, "Record Updated Successfully"))
      } catch (error) {
        yield put(
          addCompanyError(
            (error && error.response && error.response.message) ||
              "Updated Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}
export default function* recordsSaga() {
  yield all([
    loadRecordsMetaDataSaga(),
    loadEmployeeSaga(),
    loadObsDetailsSaga(),
    addAssignSaga(),
    addFollowUpSaga(),
    loadFollowUpSaga(),
    loadCompanySaga(),
    addCompanySaga()
  ])
}
